import { z } from 'zod/v3';

export const withMetadata = (schema, metadata) => {
  schema._def.meta = metadata;
  return schema;
};

export const HubspotCredentialsSchema = z.object({
  accessToken: withMetadata(z.string(), {
    displayName: 'Access Token',
    type: 'password',
  }),
});

export const KlaviyoCredentialsSchema = z.object({
  privateKey: withMetadata(z.string(), {
    displayName: 'Private Key',
    type: 'password',
  }),
});

export const BrazeCredentialsSchema = z.object({
  apiKey: withMetadata(z.string(), { displayName: 'Api Key' }),
});

export const ShopifyCredentialsSchema = z.object({
  accessToken: withMetadata(z.string(), {
    displayName: 'Access Token',
    type: 'password',
  }),
});

const ZendeskLegacyCredentialsSchema = z.object({
  apiToken: withMetadata(z.string(), {
    displayName: 'Api Token',
    type: 'password',
  }),
  email: z.string().email(),
  endpoint: withMetadata(z.string().url().optional(), {
    displayName: 'Endpoint',
  }),
});

const ZendeskOAuthCredentialsSchema = z.object({
  clientId: withMetadata(z.string(), {
    displayName: 'Client ID',
  }),
  clientSecret: withMetadata(z.string(), {
    displayName: 'Client Secret',
    type: 'password',
  }),
  subdomain: withMetadata(z.string(), {
    displayName: 'Subdomain',
  }),
});

export const ZendeskCredentialsSchema = z.union([
  ZendeskLegacyCredentialsSchema,
  ZendeskOAuthCredentialsSchema,
]);

export const SalesforceCredentialsSchema = z.object({
  clientId: z.string(),
  clientSecret: withMetadata(z.string(), {
    displayName: 'Client Secret',
    type: 'password',
  }),
  instance: withMetadata(z.string(), {
    displayName: 'Instance name',
  }),
});

export const KustomerCredentialsSchema = z.object({
  apiKey: withMetadata(z.string(), {
    displayName: 'Api Key',
    type: 'password',
  }),
});

export const AttioCredentialsSchema = z.object({
  accessToken: withMetadata(z.string(), {
    displayName: 'Acces Token',
    type: 'password',
  }),
});

export const LinearCredentialsSchema = z.object({
  apiKey: withMetadata(z.string(), {
    displayName: 'Api Key',
    type: 'password',
  }),
});

export const DevinCredentialsSchema = z.object({
  apiKey: withMetadata(z.string(), {
    displayName: 'Api Key',
    type: 'password',
  }),
});
